<template>
  <div>
    <div class="game-control-bar">
      <i class="icon iconfont icon-class"></i>
      <p>{{ title }}</p>
      <span class="exit" v-if="!isForced" @click="close">
        <i class="iconfont icon-exit" title="退出"></i><span>退出</span>
      </span>
    </div>
    <el-progress :text-inside="true" :stroke-width="2" :percentage="progress"></el-progress>
  </div>
</template>

<script>
import { Progress } from 'element-ui';

export default {
  components: {
    ElProgress: Progress,
  },
  props: {
    title: {
      type: String,
      default: '课程名称',
    },
    progress: {
      type: Number,
      default: 0,
    },
    isForced: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .game-control-bar {
    padding: 0 20px 5px;
    display: flex;
    align-items: center;
    margin-top: 10px;
    border-bottom: 1px solid $gray-bg-color;
    .exit {
      cursor: pointer;
      span {
        overflow: hidden;
        display: inline-block;
      }
    }
    p {
      flex: 1;
      margin: 0;
    }
    i {
      cursor: pointer;
      font-size: 30px;
      color: $primary;
      &:hover {
        opacity: .9;
      }
      &:first-child {
        margin-left: 0;
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 20px;
      }
    }
  }
</style>
